import React, { useState, useContext, useRef, useEffect } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom'; // Import Link
import { Form, Button, Alert, Container, Row, Col, Image } from 'react-bootstrap';
import GoogleLoginButton from './GoogleLoginButton'; // Import GoogleLoginButton
import { Fade } from 'react-awesome-reveal'; // Import Fade
import logo from '../../assets/app-logo.png';
import { friendlyAuthError } from './authErrors';

// Import the specific CSS for this component
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useContext(AuthContext); // Assuming login handles email/pass
    const navigate = useNavigate();
    const errorRef = useRef(null);

    // Move focus to the error so it is read out and the user knows the submit
    // failed — the alert alone leaves keyboard focus on the Sign In button.
    useEffect(() => {
        if (error) errorRef.current?.focus();
    }, [error]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await login(email, password);
            navigate('/dashboard'); // Navigate after successful login
        } catch (err) {
            setError(friendlyAuthError(err, 'Login failed. Please check your credentials.'));
            console.error("Login error:", err);
        }
    };

    return (
        // Main container with padding and background
        <main id="main-content" className="login-page-container">
            <Container className='form-container'>
                <Row className="justify-content-center h-100">
                    <Col xs={11} sm={9} md={7} lg={4}>
                        <Link to="/" className="d-inline-block hide-on-mobile">
                            <Image src={logo} alt="Right Spade Home" className='mb-3 ms-4 ms-md-0 logo-img' />
                        </Link>
                        {/* Add Fade animation */}
                        <Fade direction="up" triggerOnce cascade damping={0.1} >
                            {/* Wrapper for the form card styling */}
                            <div className="login-form-wrapper">
                                <h1 className="login-title">Sign In</h1>
                                {error && (
                                    <Alert variant="danger" ref={errorRef} tabIndex={-1}>{error}</Alert>
                                )}
                                <Form onSubmit={handleSubmit} className='form-wrap'>
                                    <div className="form-fld-wrp">

                                        <Form.Group className="mb-3" controlId="formLoginEmail">
                                            <Form.Label>E-mail Address</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Enter email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                                aria-invalid={error ? 'true' : undefined}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3" controlId="formLoginPassword">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Password"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                required
                                                aria-invalid={error ? 'true' : undefined}
                                            />
                                            {/* Optional: Add Forgot Password Link */}
                                            <div className="text-end mt-1">
                                                <Link to="/forgot-password" style={{ fontSize: '0.85rem' }}>Forgot Password?</Link>
                                            </div>
                                        </Form.Group>
                                    </div>

                                    <div className="form-footer">
                                        <Button variant="primary" type="submit" className="login-button">
                                            Sign In
                                        </Button>

                                        {/* Divider */}
                                        <div className="divider-or">OR</div>

                                        {/* Google Login Button */}
                                        <div className="google-login-button-wrapper"> {/* Wrapper for specific styling */}
                                            <GoogleLoginButton />
                                        </div>

                                        <p className="register-link-text mt-4"> {/* Increased margin-top */}
                                            <Link to="/register"> Don't have an account?</Link>
                                        </p>
                                    </div>
                                </Form>

                                {/* Link to Register Page */}
                            </div>
                        </Fade>
                    </Col>
                </Row>
            </Container>
        </main>
    );
};

export default Login;